export enum INPUT_STATE {
  DEFAULT = 'default',
  ERROR = 'error',
  FOCUSED = 'focused',
  DISABLED = 'disabled'
}

export enum INPUT_VARIANT {
  SQUARED = 'squared',
  ROUNDED = 'rounded',
  UNDERLINED = 'underlined'
}

export enum INPUT_SIZE {
  EXTRA_SMALL = 'extraSmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}
